module.exports = __webpack_public_path__ + "img/loz-takoz-urban-taqueria-logo.b8b0f8b9.png";